import pickBy from 'lodash/pickBy';

export const mapContact = body => {
  return { ...pickBy(body || {}, v => v !== null && v !== undefined && v !== '') };
};
